import { i as p } from "./modal.css-DWsl4ezd.js";
import "./sp-button-fa52iiKJ.js";
import "./sp-dialog-C9swJ4nV.js";
import { i as c, x as h, T as m } from "./lit-element-6iugfgmM.js";
import { f as u } from "./first-focusable-in-C_FjNeTy.js";
import { a as y } from "./focusable-2cSgEeBs.js";
import { n as a } from "./property-BWlAHqg_.js";
import { S as v } from "./Base-pdJ5fkYW.js";
import { d as g } from "./define-element-Dl91r6Vu.js";
const b = c`
    :host{box-sizing:border-box;inline-size:100vw;block-size:100vh;block-size:-webkit-fill-available;block-size:stretch;visibility:hidden;pointer-events:none;z-index:1;transition:visibility 0s linear var(--mod-modal-transition-animation-duration,var(--spectrum-animation-duration-100));justify-content:center;align-items:center;display:flex;position:fixed;inset-block-start:0;inset-inline-start:0}:host([open]){visibility:visible}@media only screen and (device-height<=350px),only screen and (device-width<=400px){:host([responsive]){inline-size:100%;block-size:100%;max-inline-size:100%;max-block-size:100%;border-radius:0}:host([responsive]){margin-block-start:0}}
`;
var f = Object.defineProperty, r = (l, i, e, n) => {
  for (var s, t = void 0, d = l.length - 1; d >= 0; d--) (s = l[d]) && (t = s(i, e, t) || t);
  return t && f(i, e, t), t;
};
class o extends y(v) {
  constructor() {
    super(...arguments), this.dismissable = !1, this.open = !1, this.responsive = !1, this.transitionPromise = Promise.resolve(), this.resolveTransitionPromise = () => {
    }, this.underlay = !1, this.animating = !1;
  }
  static get styles() {
    return [b, p];
  }
  get dialog() {
    return this.shadowRoot.querySelector("slot").assignedElements()[0] || this;
  }
  async focus() {
    if (this.shadowRoot) {
      const i = u(this.dialog);
      i ? (i.updateComplete && await i.updateComplete, i.focus()) : this.dialog.focus();
    } else super.focus();
  }
  overlayWillCloseCallback() {
    return this.open ? (this.close(), !0) : this.animating;
  }
  dismiss() {
    this.dismissable && this.close();
  }
  handleClose(i) {
    i.stopPropagation(), this.close();
  }
  close() {
    this.open = !1;
  }
  dispatchClosed() {
    this.dispatchEvent(new Event("close", { bubbles: !0 }));
  }
  handleTransitionEvent(i) {
    this.dispatchEvent(new TransitionEvent(i.type, { bubbles: !0, composed: !0, propertyName: i.propertyName }));
  }
  handleUnderlayTransitionend(i) {
    !this.open && i.propertyName === "visibility" && this.resolveTransitionPromise(), this.handleTransitionEvent(i);
  }
  handleModalTransitionend(i) {
    (this.open || !this.underlay) && this.resolveTransitionPromise(), this.handleTransitionEvent(i);
  }
  get hasTransitionDuration() {
    const i = this.shadowRoot.querySelector(".modal"), e = window.getComputedStyle(i).transitionDuration;
    for (const s of e.split(",")) if (parseFloat(s) > 0) return !0;
    const n = this.shadowRoot.querySelector("sp-underlay");
    if (n) {
      const s = window.getComputedStyle(n).transitionDuration;
      for (const t of s.split(",")) if (parseFloat(t) > 0) return !0;
    }
    return !1;
  }
  update(i) {
    if (i.has("open") && i.get("open") !== void 0) {
      const e = this.hasTransitionDuration;
      this.animating = !0, this.transitionPromise = new Promise((n) => {
        this.resolveTransitionPromise = () => {
          this.animating = !1, !this.open && e && this.dispatchClosed(), n();
        };
      }), !this.open && !e && this.dispatchClosed();
    }
    super.update(i);
  }
  renderDialog() {
    return h`
            <slot></slot>
        `;
  }
  render() {
    return h`
            ${this.underlay ? h`
                      <sp-underlay
                          ?open=${this.open}
                          @close=${this.dismiss}
                          @transitionrun=${this.handleTransitionEvent}
                          @transitionend=${this.handleUnderlayTransitionend}
                          @transitioncancel=${this.handleTransitionEvent}
                      ></sp-underlay>
                  ` : m}
            <div
                class="modal ${this.mode}"
                @transitionrun=${this.handleTransitionEvent}
                @transitionend=${this.handleModalTransitionend}
                @transitioncancel=${this.handleTransitionEvent}
                @close=${this.handleClose}
            >
                ${this.renderDialog()}
            </div>
        `;
  }
  updated(i) {
    i.has("open") && this.open && "updateComplete" in this.dialog && "shouldManageTabOrderForScrolling" in this.dialog && this.dialog.updateComplete.then(() => {
      this.dialog.shouldManageTabOrderForScrolling();
    });
  }
  async getUpdateComplete() {
    const i = await super.getUpdateComplete();
    return await this.transitionPromise, i;
  }
}
r([a({ type: Boolean, reflect: !0 })], o.prototype, "dismissable"), r([a({ type: Boolean, reflect: !0 })], o.prototype, "open"), r([a({ type: String, reflect: !0 })], o.prototype, "mode"), r([a({ type: Boolean })], o.prototype, "responsive"), r([a({ type: Boolean })], o.prototype, "underlay"), g("sp-dialog-base", o);
//# sourceMappingURL=sp-dialog-base-CHozb5nU.js.map
